let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("4C3hu")).then(() => parcelRequire('21OVa'));